import React from 'react'
import { Icon } from '@islandsstofa/react'
import Checkbox from '@cmp/site/Checkbox'
import cn from 'classnames'
import { BooleanObjectType } from '../DropdownTree'

interface DropdownProps {
  open: BooleanObjectType
  setOpen: (open: BooleanObjectType) => void
  categories: BooleanObjectType
  category: string
  onSelect: (value: string) => void
  allSelected: boolean
  label: string
  index: number
}

const Dropdown = ({
  open,
  setOpen,
  categories,
  category,
  onSelect,
  allSelected,
  label,
  index
}: DropdownProps) => {
  return (
    <div>
      <div
        className='filter-dropdown__overlay'
        onClick={() => setOpen({})}
        style={{ zIndex: Object.keys(open).length > 0 ? 60 : -1 }}
      ></div>
      <span>{label}</span>
      <div
        className={cn('d-flex flex-column filter-dropdown__box p-1 mt-1 mb-2', {
          'filter-dropdown__box--open': open[category]
        })}
        style={{ zIndex: index }} // So dropdowns stack properly on top of each other in mobile view
      >
        <div
          className='d-flex align-items-center justify-content-between'
          onClick={() => setOpen({ ...open, [category]: !open[category] })}
        >
          <div>
            <Checkbox
              checked={allSelected || false}
              id={`${category}_all`}
              onChange={() => onSelect('all')}
              label='Velja allt'
            />
          </div>
          <Icon className='mr-1' type='arrowDown' />
        </div>
        <div
          className={cn('filter-dropdown__content', {
            'filter-dropdown__content--open': open[category]
          })}
        >
          {Object.keys(categories).map((tag, idx) => (
            <div
              key={idx}
              className='filter-dropdown__content__item p-1 filter-dropdown__input'
            >
              <Checkbox
                checked={categories[tag]}
                id={`${category}_${tag}`}
                onChange={() => onSelect(tag)}
                label={tag}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Dropdown
